<template>
  <span :class="colorCls">
    <span v-if="drawBrace" class="brace1"> { </span>
    <span v-for="item in p.print" :key="'deg' + item.deg" class="term">
      <span v-if="item.sign != ''" class="operator"> {{item.sign}} </span>
      {{item.coeff}}
      <span v-if="item.deg > 0">
	x
	<sup v-if="item.deg > 1">{{item.deg}}</sup>
      </span>
    </span>
    <span v-if="drawBrace" class="brace1"> } </span>
  </span>
</template>

<script>
import { Polynominal } from '@/lib/poly.js';

export default {
  name: 'Showpoly',
  props: {
    p: Polynominal,
    brace: {type: Boolean, default: false},
    color: {type: Number, default: 0}
  },
  computed: {
    drawBrace(){
      return this.brace && (this.p.print.length > 1 || this.p.print[0].sign == '-');
    },
    colorCls(){
      return ['black','red','orange','green','blue','violet'][this.color];
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.black {
    color: #000;
}
.red {
    color: #f00;
}
.orange {
    color: #f80;
}
.yellow {
    color: #bb0;
}
.green {
    color: #080;
}
.blue {
    color: #00b;
}
.violet {
    color: #808;
}
</style>
